import { ImmomioButtonComponent } from '@immomio/ui/button';
import {
  Component,
  inject,
  input,
  OnInit,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  NgbActiveModal,
  NgbNav,
  NgbNavContent,
  NgbNavItem,
  NgbNavLink,
  NgbNavLinkBase,
  NgbNavOutlet
} from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslatePipe } from '@ngx-translate/core';
import { UserSettingsConversationConfig } from '@ui/shared/model';
import { ModalFooterComponent } from '../../../modal/modal-footer/modal-footer.component';
import { MessageTemplatesComponent } from '../message-templates/message-templates.component';
import { ConversationRestrictionConfigFormComponent } from '../conversation-restriction-config-form/conversation-restriction-config-form.component';
import { ModalContentComponent } from '../../../modal/modal-content/modal-content.component';
import { ModalComponent } from '../../../modal/modal.component';
import { DEFAULT_CONVERSATION_RESTRICTION_CONFIG } from '../../model/enum';
import { MessageTemplate } from '../../model/interface';
import { stripTypenameProperty } from '../../../../../utils/strip-typename-property';
import { ConversationGeneralConfigFormComponent } from './conversation-general-config-form/conversation-general-config-form.component';

@Component({
  selector: 'app-chat-settings',
  templateUrl: './chat-settings-modal.component.html',
  styleUrls: ['./chat-settings-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImmomioButtonComponent,
    ModalComponent,
    ModalContentComponent,
    NgbNav,
    NgbNavItem,
    NgbNavLink,
    NgbNavLinkBase,
    NgbNavContent,
    ConversationGeneralConfigFormComponent,
    FormsModule,
    ReactiveFormsModule,
    ConversationRestrictionConfigFormComponent,
    MessageTemplatesComponent,
    NgbNavOutlet,
    ModalFooterComponent,
    TranslatePipe
  ]
})
export class ChatSettingsModalComponent implements OnInit {
  private ngbActiveModal = inject(NgbActiveModal);

  public restrictionConfigFormControl: FormControl;
  public generalConfigFormControl: FormControl;
  public userSettingsConversationConfig =
    input<UserSettingsConversationConfig>(undefined);
  public activeTab = input<string>(undefined);
  public conversationMessageTemplateSubstitutionTags = input<any>(undefined);
  public newTemplateData = input<MessageTemplate>(undefined);

  public save = input<
    (messageTemplate: UserSettingsConversationConfig) => void
  >(() => {
    // Placeholder
  });

  public saveControlValues() {
    return this.save()({
      ...this.generalConfigFormControl.value,
      restrictionConfig: this.restrictionConfigFormControl.value
    });
  }

  public ngOnInit() {
    const { restrictionConfig, ...generalConfig } =
      this.userSettingsConversationConfig() || {};

    this.generalConfigFormControl = new FormControl(
      stripTypenameProperty(generalConfig)
    );

    const strippedRestrictionConfig = stripTypenameProperty(restrictionConfig);
    this.restrictionConfigFormControl = new FormControl(
      restrictionConfig &&
        !Object.values(strippedRestrictionConfig).every(c => !c)
        ? strippedRestrictionConfig
        : DEFAULT_CONVERSATION_RESTRICTION_CONFIG
    );
  }

  public controlsNeverTouched() {
    return !(
      this.restrictionConfigFormControl.touched ||
      this.generalConfigFormControl.touched
    );
  }

  public close() {
    this.ngbActiveModal.close();
  }

  public dismiss() {
    this.ngbActiveModal.dismiss();
  }
}
